<template>
    <div>
        <navbar />

        <banner />

        <offers />

        <packs />

        <contacts />

        <discounts />

        <experiences />

        <Footer />
    </div>
</template>

<script>
import Navbar from './sections/Navbar.vue';
import Banner from './sections/Banner.vue';
import Offers from './sections/Offers.vue';
import Packs from './sections/Packs.vue';
import Contacts from './sections/Contacts.vue';
import Discounts from './sections/Discounts.vue';
import Experiences from './sections/Experiences.vue';
import Footer from './../../components/Footer.vue';

export default {
  title: 'Início',
  components: {
    Navbar,
    Banner,
    Offers,
    Packs,
    Contacts,
    Discounts,
    Experiences,
    Footer
  }
}
</script>